import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { createContext } from 'react';
import UserStore from './store/UserStore';
import BrickStore from './store/BrickStore';
import ApplicationStore from './store/ApplicationStore';


export const Context = createContext(null)

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Context.Provider value={{
      user: new UserStore(),
      bricks: new BrickStore(),
      application: new ApplicationStore()
      }}>
      <App/>
    </Context.Provider>
  </React.StrictMode>
);
